import { connectWithStore } from '@common/connectWithStore';
import { getState } from '@redux/ducks/account/pricingPlan/pricingPlans';
import { PricingPlansContent } from './PricingPlansContent';

const mapStateToProps = state => {
  const { isDataLoaded, plans } = getState(state);

  const hasAvailablePlans = isDataLoaded && !!plans?.length;

  return { hasAvailablePlans };
};

export const PricingPlansContentContainer = connectWithStore(mapStateToProps)(PricingPlansContent);
